var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"case"},[_c('div',{staticClass:"center"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],staticStyle:{"height":"30em","width":"30em"}})]),_c('div',{staticStyle:{"margin-top":"200px"}},[_c('Footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }